import type { ReactElement } from 'react';

import { Highlight } from '@frontend/components';

import type { HighlightableConstituent, PartProps } from '../Part';
import { getHighlightQueryStringForConstituent } from './getHighlightQueryStringForConstituent';

export type ApplyHighlightingParams = {
  contentToHighlight: string | null | undefined;
  constituent: HighlightableConstituent;
  highlight: PartProps['highlight'];
};

export const applyHighlighting = ({
  contentToHighlight,
  constituent,
  highlight,
}: ApplyHighlightingParams): ReactElement | string | null | undefined => {
  if (contentToHighlight && highlight) {
    const highlightQueryString = getHighlightQueryStringForConstituent({
      constituent,
      highlight,
    });

    if (highlightQueryString) {
      return (
        <Highlight query={[highlightQueryString]}>
          {contentToHighlight}
        </Highlight>
      );
    }
  }

  return contentToHighlight;
};
